import { fonts as _ } from "@typedream/core";
const t = 700, o = 70, L = 17, n = 0.6, M = 0.8, T = "inter";
({
  ..._,
  [T]: _.inter
});
export {
  T as DEFAULT_FONT_FAMILY_NAME,
  t as MAX_WIDTH,
  o as TEXT_MOBILE_BIG_CUTOFF,
  n as TEXT_MOBILE_BIG_PERCENT,
  L as TEXT_MOBILE_SMALL_CUTOFF,
  M as TEXT_MOBILE_SMALL_PERCENT
};
